export const GET_MACHINE_CENTER_REQUEST = "GET_MACHINE_CENTER_REQUEST";
export const GET_MACHINE_CENTER_SUCCESS = "GET_MACHINE_CENTER_SUCCESS";
export const GET_MACHINE_CENTER_FAILURE = "GET_MACHINE_CENTER_FAILURE";

export const GET_MACHINE_FOR_DROPDOWN_REQUEST =
  "GET_MACHINE_FOR_DROPDOWN_REQUEST";
export const GET_MACHINE_FOR_DROPDOWN_SUCCESS =
  "GET_MACHINE_FOR_DROPDOWN_SUCCESS";
export const GET_MACHINE_FOR_DROPDOWN_FAILURE =
  "GET_MACHINE_FOR_DROPDOWN_FAILURE";

export const CREATE_MACHINE_CENTER_REQUEST = "CREATE_MACHINE_CENTER_REQUEST";
export const CREATE_MACHINE_CENTER_SUCCESS = "CREATE_MACHINE_CENTER_SUCCESS";
export const CREATE_MACHINE_CENTER_FAILURE = "CREATE_MACHINE_CENTER_FAILURE";

export const UPDATE_MACHINE_CENTER_REQUEST = "UPDATE_MACHINE_CENTER_REQUEST";
export const UPDATE_MACHINE_CENTER_SUCCESS = "UPDATE_MACHINE_CENTER_SUCCESS";
export const UPDATE_MACHINE_CENTER_FAILURE = "UPDATE_MACHINE_CENTER_FAILURE";

export const DELETE_DELETE_REQUEST = "DELETE_DELETE_REQUEST";
export const DELETE_DELETE_SUCCESS = "DELETE_DELETE_SUCCESS";
export const DELETE_DELETE_FAILURE = "DELETE_DELETE_FAILURE";

export const GET_LABELS_WITH_PAGINATION_REQUEST =
  "GET_LABELS_WITH_PAGINATION_REQUEST";
export const GET_LABELS_WITH_PAGINATION_SUCCESS =
  "GET_LABELS_WITH_PAGINATION_SUCCESS";
export const GET_LABELS_WITH_PAGINATION_FAILURE =
  "GET_LABELS_WITH_PAGINATION_FAILURE";

export const GET_PRINTERS_FOR_LABEL_REQUEST = "GET_PRINTERS_FOR_LABEL_REQUEST";
export const GET_PRINTERS_FOR_LABEL_SUCCESS = "GET_PRINTERS_FOR_LABEL_SUCCESS";
export const GET_PRINTERS_FOR_LABEL_FAILURE = "GET_PRINTERS_FOR_LABEL_FAILURE";

export const GET_LOCATIONS_BY_MACHINE_REQUEST =
  "GET_LOCATIONS_BY_MACHINE_REQUEST";
export const GET_LOCATIONS_BY_MACHINE_SUCCESS =
  "GET_LOCATIONS_BY_MACHINE_SUCCESS";
export const GET_LOCATIONS_BY_MACHINE_FAILURE =
  "GET_LOCATIONS_BY_MACHINE_FAILURE";

export const GET_WORKCENTER_BY_MACHINE_REQUEST =
  "GET_WORKCENTER_BY_MACHINE_REQUEST";
export const GET_WORKCENTER_BY_MACHINE_SUCCESS =
  "GET_WORKCENTER_BY_MACHINE_SUCCESS";
export const GET_WORKCENTER_BY_MACHINE_FAILURE =
  "GET_WORKCENTER_BY_MACHINE_FAILURE";

export const UPDATE_MACHINE_STATUS_REQUEST = "UPDATE_MACHINE_STATUS_REQUEST";
export const UPDATE_MACHINE_STATUS_SUCCESS = "UPDATE_MACHINE_STATUS_SUCCESS";
export const UPDATE_MACHINE_STATUS_FAILURE = "UPDATE_MACHINE_STATUS_FAILURE";

export const GET_MAPPED_MACHINES_REQUEST = "GET_MAPPED_MACHINES_REQUEST";
export const GET_MAPPED_MACHINES_SUCCESS = "GET_MAPPED_MACHINES_SUCCESS";
export const GET_MAPPED_MACHINES_FAILURE = "GET_MAPPED_MACHINES_FAILURE";
